<aw-floating-dialog
  position="right"
  [sideOffset]="24"
  [bottomOffset]="24"
  [config]="floatingDialogConfig"
  [buttonConfig]="floatingDialogButtonConfig"
  [dismissButtonLabel]="thePlugin?.messages.close"
>
  <i class="material-icons" aria-hidden="true" modal-close>close</i>
  <h3 modal-header>{{ dialogHeader$ | async }}</h3>
  <div #modalContainer class="dialog-modal-container"></div>
</aw-floating-dialog>
